import { createImagePicker } from "../imagePicker.js";

export function structureContact(id) {
  return `
        <div>
            <div class="title-box">
                <div class="title-text"><i class="bi bi-person-lines-fill"></i> Kontaktformular</div>
                <button type="button" class="btn-node-delete" title="Element entfernen" aria-label="Element entfernen"><i class="bi bi-x-lg"></i></button>
            </div>
            <hr>
            <div class="content-box">
                <div class="row">
                    <div class="form-group">
                        <label class="col-12">Überschrift</label>
                        <div class="col-12">
                            <input type="text" class="form-control form-control-sm" df-header>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group">
                        <label class="col-12">Einleitung</label>
                        <div class="col-12">
                            <textarea class="form-control form-control-sm" df-description rows="3" style="height: 100%"></textarea>
                        </div>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="form-group">
                        <label class="col-12">Bild (optional)</label>
                        <div class="col-12">
                            ${createImagePicker(id, "frageimg", "df-frageimg")}
                        </div>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="form-group">
                        <label class="col-12">Email abfragen?</label>
                        <div class="col-12">
                            <select class="form-select form-select-sm" df-mail>
                                <option value="0">nein</option>
                                <option value="1" selected>ja (Pflichtfeld)</option>
                                <option value="optional">ja (optional)</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="form-group">
                        <label class="col-12">Telefon abfragen?</label>
                        <div class="col-12">
                            <select class="form-select form-select-sm phone-toggle" df-phone>
                                <option value="0">nein</option>
                                <option value="1">ja (Pflichtfeld)</option>
                                <option value="optional" selected>ja (optional)</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="form-group">
                        <label class="col-12">Teilnahmebedingungen?</label>
                        <div class="col-12">
                            <select class="form-select form-select-sm conditions-toggle" df-conditions>
                                <option value="0" selected>nein</option>
                                <option value="1">ja (Pflichtfeld)</option>
                                <option value="optional">ja (optional)</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="row mt-2 conditions-text-row" style="display: none">
                    <div class="form-group">
                        <label class="col-12">Bedingungen (Text für Akkordeon)</label>
                        <div class="col-12">
                            <textarea class="form-control form-control-sm" df-conditionstext rows="3" placeholder="Hier den Text der Teilnahmebedingungen eingeben..."></textarea>
                        </div>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="form-group">
                        <label class="col-12">Datenschutz bestätigen lassen?</label>
                        <div class="col-12">
                            <select class="form-select form-select-sm datenschutz-toggle" df-datenschutz>
                                <option value="0" selected>nein</option>
                                <option value="1">ja (Pflichtfeld)</option>
                                <option value="optional">ja (optional)</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="row mt-2 datenschutz-url-row" style="display: none">
                    <div class="form-group">
                        <label class="col-12">Link zur Datenschutzerklärung</label>
                        <div class="col-12">
                            <input type="text" class="form-control form-control-sm" df-datenschutzurl placeholder="https://deine-website.de/datenschutz">
                        </div>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="form-group">
                        <label class="col-12">Button</label>
                        <div class="col-12">
                            <input type="text" class="form-control form-control-sm" df-button>
                        </div>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="form-group">
                        <label class="col-12">Benachrichtigungskanal</label>
                        <div class="col-12">
                            <select class="form-select form-select-sm channel-toggle" df-notificationChannel>
                                <option value="">-- Kein Versand --</option>
                                <option value="EMAIL">E-Mail</option>
                                <option value="WHATSAPP_TEMPLATE">WhatsApp</option>
                                <option value="SMS">SMS</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="row mt-2 template-row" style="display: none">
                    <div class="form-group">
                        <label class="col-12">Vorlage</label>
                        <div class="col-12">
                            <select class="form-select form-select-sm template-select" df-notificationTemplateId>
                                <option value="">-- Keine Vorlage --</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <button type="button" class="btn btn-sm btn-outline-secondary w-100 btn-options-toggle my-2" data-bs-toggle="collapse" data-bs-target="#node${id}-options">
                <i class="bi bi-gear-fill me-1"></i> Weitere Optionen
            </button>
            <div id="node${id}-options" class="options collapse">
                <div class="row">
                    <div class="form-group">
                        <label class="col-12">Kundenstatus abfragen?</label>
                        <div class="col-12">
                            <select class="form-select form-select-sm" df-member>
                                <option value="0" selected>nein</option>
                                <option value="1">ja</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="row chatbot-row" style="display: none">
                    <div class="form-group">
                        <label class="col-12">Chatbot aktivieren</label>
                        <div class="col-12">
                            <input type="text" class="form-control form-control-sm" placeholder="ID der Kontaktliste" df-chatbot>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group">
                        <label class="col-12">Geburtsdatum abfragen?</label>
                        <div class="col-12">
                            <select class="form-select form-select-sm" df-date>
                                <option value="0" selected>nein</option>
                                <option value="1">ja</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group">
                        <label class="col-12">Adresse abfragen?</label>
                        <div class="col-12">
                            <select class="form-select form-select-sm" df-address>
                                <option value="0" selected>nein</option>
                                <option value="1">ja</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group">
                        <label class="col-12">Weiterleitung (optional)</label>
                        <div class="col-12">
                            <input type="text" class="form-control form-control-sm" df-redirect>
                        </div>
                    </div>
                </div>
            </div>
        </div>`;
}
